import { SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import React from 'react';
import { Helmet } from 'react-helmet';

import { ProfileSetupForm } from '../resources/components';
import { PreAhaMoment } from '../resources/components';
import { useProfileSetupSsoPage } from './resources/hooks';
import { messages } from './resources/messages';
import { ProfileSetupSsoStep } from './resources/types';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const { profileData, isLoading, hasInvitations, useCases, answerAboutGL, step, handleSubmit, handlePreAhaNext } =
        useProfileSetupSsoPage();

    return (
        <SimpleLayout size={step === ProfileSetupSsoStep.PreAhaMoment ? 'large' : 'xsmall'}>
            <Helmet>
                <title>{messages.pageTitle}</title>
            </Helmet>

            <SimpleLayout.Content>
                {
                    {
                        [ProfileSetupSsoStep.Profile]: (
                            <ProfileSetupForm
                                email={profileData.email}
                                profileData={profileData}
                                isLoading={isLoading}
                                showConsent
                                showQuestions={!hasInvitations}
                                showPhoneField={!hasInvitations}
                                onSubmit={handleSubmit}
                            />
                        ),
                        [ProfileSetupSsoStep.PreAhaMoment]: (
                            <PreAhaMoment answerAboutGL={answerAboutGL} useCases={useCases} onNext={handlePreAhaNext} />
                        ),
                    }[step]
                }
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

export default Page;
